export enum FormFields {
  messagesEnabled = 'messagesEnabled',
  tipsEnabled = 'tipsEnabled',
  minTipEnabled = 'minTipEnabled',
  minTipAmount = 'minTipAmount',
}

export type FormValues = {
  [FormFields.messagesEnabled]?: boolean
  [FormFields.tipsEnabled]?: boolean
  [FormFields.minTipEnabled]?: boolean
  [FormFields.minTipAmount]?: number
}
